<script>
    import { createEventDispatcher } from "svelte";
    import ShadowCard from "./ShadowCard.svelte";
    import { slide } from "svelte/transition";
    // event handler for Collapse Arrow
    function ToggleCollapsed() {
        isCollapsed = !isCollapsed;
    }

    // Task props
    export let leadingIconActive = "check",
        leadingIconLocked = "lock",
        leadingComponentActive = null,
        trailingIcon = "expand_more",
        logoComponent = "",
        isActive = true,
        isCollapsed = true,
        expandedDescription = "",
        collapsedDescription = "";

    $: isActiveClass = isActive ? "active" : "";
    $: cardLeading = isActive === true ? leadingIconActive : leadingIconLocked;
    $: cardClass = isCollapsed ? "card collapsed" : "card";
    $: logoFillColor = isCollapsed ? "#333" : "#fff";
</script>

<!--src/components/DisclosureCard.svelte-->
<ShadowCard>
    <div class="{cardClass} {isActiveClass}" transition:slide|local>
        <div class="header">
            <!-- {#if isCollapsed} -->
                <div class="leading">
                    {#if leadingComponentActive}
                        <svelte:component this="{leadingComponentActive}" />
                    {:else}
                        <i class="material-icons">{cardLeading}</i>
                    {/if}
                </div>
            <!-- {/if} -->
            <div class="title">
                <svelte:component this="{logoComponent}" {logoFillColor} />
            </div>
            {#if isCollapsed}
                <div class="description">{@html collapsedDescription}</div>
            {:else}
                <div class="description">{@html expandedDescription}</div>
            {/if}
            <div class="trailing toggle">
                <i
                    class="material-icons"
                    on:click="{() => {
                        ToggleCollapsed();
                    }}"
                >
                    {trailingIcon}
                </i>
            </div>
        </div>
        {#if !isCollapsed}
            <div class="body" transition:slide|local>
                <slot />
            </div>
        {/if}
    </div>
</ShadowCard>

<style>
    .card {
        display: flex;
        flex-flow: row wrap;
        border-radius: 6px;
        margin: auto;
    }

    /* card header */
    .header {
        width: 100%;
        display: flex;
        flex-wrap: nowrap;
        height: 64px;
        box-shadow: none;
    }
    .header * {
        display: flex;
        justify-content: center;
        align-items: center;
        user-select: none;
    }
    .header div {
        background-color: var(--inactiveColor);
        color: var(--backgroundColorLightest);
    }

    /* header leading icon */
    .header .leading {
        border-bottom-left-radius: 0px;
        border-top-left-radius: 6px;
        width: 10%;
        max-width: 64px;
    }
    .collapsed .header {
        border-radius: 6px;
        color: var(--backgroundColorLightest);
        box-shadow: none;
    }
    .collapsed .header .leading {
        border-top-left-radius: 6px;
        border-bottom-left-radius: 6px;
        width: 10%;
        max-width: 64px;
        background-color: var(--inactiveColor);
    }
    .collapsed .header div:not(.leading) {
        background-color: var(--backgroundColorDark);
        color: var(--textColorDarkest);
    }
    .active.collapsed .header div:not(.leading) {
        background-color: var(--backgroundColorLightest);
    }

    /* round-out top left corner. */
    .header :first-child {
        border-top-left-radius: 6px;
    }
    .active .header div:not(.leading) {
        background-color: var(--primaryColor);
        color: var(--backgroundColorLightest);
    }
    .active.collapsed .header div:not(.leading) {
        background-color: var(--backgroundColorLightest);
        color: var(--textColorDarkest);
    }
    .active .header .leading {
        background-color: var(--primaryColor);
    }
    /* div.card:not(.collapsed) .title {
        padding-left: 32px;
    } */
    .header .leading i {
        color: var(--backgroundColorLightest);
    }
    i.material-icons {
        width: 50%;
        font-size: 28px;
    }
    .trailing i {
        cursor: pointer;
    }
    .no-touch .collapsed .trailing i:hover {
        color: var(--primaryColor);
    }
    .header .title {
        font-size: 24px;
        flex: 1;
        justify-content: flex-start;
    }
    .header .description {
        display: none;
    }
    .header .trailing {
        border-top-right-radius: 6px;
        border-bottom-right-radius: 0px;
        cursor: pointer;
        flex: 0 1 48px;
        max-width: 64px;
    }
    .collapsed .header .trailing {
        border-top-right-radius: 6px;
        border-bottom-right-radius: 6px;
        flex: 0 1 48px;
        max-width: 64px;
    }
    /* rotate 180 degrees when expanded */
    .header .trailing i {
        transform: rotate(-180deg);
    }
    .collapsed .trailing i {
        transform: none;
    }
    .body {
        background-color: var(--backgroundColorLightest);
        box-shadow: none;
        display: flex;
        flex-flow: row wrap;
        margin: 24px;
        width: 100%;
    }
    .footer {
        margin: 16px;
        width: 100%;
    }
    .footer div {
        margin: 8px;
    }

    div.hr {
        height: 1px;
        background-color: var(--backgroundColorMedium);
        width: 100%;
        margin: 8px auto;
    }
    .title {
        padding-left: 4px;
    }
    /* really narrow */
    @media all and (min-width: 640px) {
        .title {
            padding-left: 24px;
        }
        .title svg {
            width: 240px;
            max-width: unset;
            min-width: unset;
        }

        .description {
            display: flex;
        }
    }
    @media all and (min-width: 912px) {
        .header .description {
            display: flex;
            font-size: 16px;
            flex: 4;
            justify-content: flex-end;
            padding-right: 24px;
        }
    }
</style>
